import { render } from "./ExpandableText.vue?vue&type=template&id=4af96b40&scoped=true&ts=true"
import script from "./ExpandableText.vue?vue&type=script&lang=ts"
export * from "./ExpandableText.vue?vue&type=script&lang=ts"

import "./ExpandableText.vue?vue&type=style&index=0&id=4af96b40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af96b40"]])

export default __exports__